let container = null;

function getContainer() {
  if (!container) {
    container = document.createElement("div");
    container.className = "toast-container";
    document.body.appendChild(container);
  }
  return container;
}

function show(text, type = "success", duration = 3000) {
  const el = document.createElement("div");
  el.className = `toast toast--${type}`;

  const icons = { success: "\u2714", error: "\u2716", warning: "\u26A0" };
  el.innerHTML = `<span class="toast__icon">${icons[type] || ""}</span><span>${text}</span>`;

  getContainer().appendChild(el);
  setTimeout(() => {
    el.style.opacity = "0";
    el.style.transition = "opacity 0.3s";
    setTimeout(() => el.remove(), 300);
  }, duration);
}

const toast = {
  success: (text) => show(text, "success"),
  error: (text) => show(text, "error"),
  warning: (text) => show(text, "warning"),
};

export default toast;
